import React from 'react';
import { Twitter, Linkedin, Instagram, Mail } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#080910] border-t border-[#F5F5F5]/5 pt-16 pb-8" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-44">
          <div data-id="element-45">
            <h3 className="text-2xl font-bold font-['Orbitron'] bg-gradient-to-r from-[#00E5FF] to-[#B721FF] text-transparent bg-clip-text mb-6" data-id="element-46">
              NEXORAQ
            </h3>
            <p className="text-[#F5F5F5]/70 mb-6" data-id="element-47">
              Transforming one-sentence ideas into thriving digital products.
            </p>
            <div className="flex space-x-4" data-id="element-48">
              <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-49">
                <Twitter size={20} data-id="element-50" />
              </a>
              <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-51">
                <Linkedin size={20} data-id="element-52" />
              </a>
              <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-53">
                <Instagram size={20} data-id="element-54" />
              </a>
              <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-55">
                <Mail size={20} data-id="element-56" />
              </a>
            </div>
          </div>
          <div data-id="element-57">
            <h4 className="text-lg font-bold font-['Orbitron'] mb-4" data-id="element-58">
              Services
            </h4>
            <ul className="space-y-2" data-id="element-59">
              <li data-id="element-60">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-61">
                  Idea-to-App Package
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-63">
                  UI/UX Design
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-65">
                  Full-Stack Development
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-67">
                  App Marketing
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-68">
            <h4 className="text-lg font-bold font-['Orbitron'] mb-4" data-id="element-69">
              Company
            </h4>
            <ul className="space-y-2" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-72">
                  About Us
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-74">
                  Case Studies
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-76">
                  Testimonials
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="text-[#F5F5F5]/70 hover:text-[#00E5FF] transition-colors" data-id="element-78">
                  Careers
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-79">
            <h4 className="text-lg font-bold font-['Orbitron'] mb-4" data-id="element-80">
              Contact
            </h4>
            <ul className="space-y-2" data-id="element-81">
              <li className="text-[#F5F5F5]/70" data-id="element-82">hello@nexoraq.com</li>
              <li className="text-[#F5F5F5]/70" data-id="element-83">+1 (888) 123-4567</li>
              <li className="text-[#F5F5F5]/70" data-id="element-84">
                123 Tech Plaza, San Francisco, CA 94107
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#F5F5F5]/5 pt-8 mt-8 text-center" data-id="element-85">
          <p className="text-[#F5F5F5]/50 text-sm" data-id="element-86">
            © {new Date().getFullYear()} Nexoraq. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};